import React from "react";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import {
  AnyEntity,
  EntityType,
  EntityTypeSupportingPreview,
} from "@mapmycustomers/shared/types/entity";

import configService from "@app/config/ConfigService";
import useEntityLinkGetter from "@app/util/contexts/useEntityLinkGetter";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { PersonFieldName } from "@app/util/fieldModel/PersonFieldModel";

import CopyLink from "./CopyLink";
import styles from "./Title.module.scss";

interface Props {
  entity: AnyEntity;
  entityType: EntityTypeSupportingPreview;
}

const Title: React.FC<Props> = ({ entity, entityType }) => {
  const intl = useIntl();
  const getEntityLink = useEntityLinkGetter();

  const nameField = getFieldModelByEntityType(entityType)?.getByName(
    entityType === EntityType.PERSON ? PersonFieldName.FIRST_NAME : "name"
  );

  return (
    <div className={styles.container}>
      <Tooltip
        title={intl.formatMessage({
          id: "recordPane.title.hiddenNameTooltip",
          defaultMessage: "Protected Information",
          description:
            "Protected information tooltip in preview pane title when the name field is hidden",
        })}
        trigger={nameField && !nameField.isReadable ? ["hover"] : []}
      >
        {"name" in entity ? entity.name : ""}
      </Tooltip>
      <CopyLink
        link={
          configService.getBaseAppUrl() + getEntityLink(entityType, entity.id, { noIframe: true })
        }
      />
    </div>
  );
};

export default Title;
